<template>
  <v-container fluid fill-height>
    <v-layout 
     justify-center 
     align-center
    >
      <v-flex xs12 md7>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Adjust Balance</v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-container fluid>
              <v-layout row>
                <v-flex xs4>
                  <v-subheader>Amount</v-subheader>
                </v-flex>
                <v-flex xs2>
                  <v-text-field label="Amount" v-model="user.amount" value="10.00" type="number" prefix="$"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs4>
                  <v-subheader>Description</v-subheader>
                </v-flex>
                <v-flex xs5>
                  <v-text-field name="input-1" label="Label Text" v-model="user.description" textarea></v-text-field>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-btn :disabled="disableButton ? true : user.amount ? user.description ? false : true : true" color="warning" @click.prevent="adjustBallance">Adjust</v-btn>
              </v-card-actions>
            </v-container>
          </v-card-title>
        </v-card>
      </v-flex>
      <div row>
          <v-alert
            :color="alert.type"
            :icon="alert.type === 'error' ? 'error' : 'check_circle'"
            :value="alert.status"
            transition="scale-transition"
          >
            {{ alert.message }}
          </v-alert>
        </div>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      disableButton: false,
      user: {
        amount: "",
        description: ""
      }
    };
  },
  methods: {
    alerting(){
      this.alert.status = !this.alert.status;
      setTimeout(() => {
            this.disableButton = false
            this.alert.status = !this.alert.status;
        }, 2500);
    },
    goBack() {
      this.$router.go(-1);
    },
    adjustBallance() {
      axios
      .post("/users/" + this.$route.params.id + "/adjustment", this.user)
      .then(res => {
        this.alert.message = 'Amount adjusted.'
        this.alert.type = 'success'
        this.alerting()
        setTimeout(() => {
            this.goBack()
        }, 2600);
      })
      .catch(err => {
        this.alert.message = err.response.data.message || 'Adjustment failed.'
        this.alert.type = 'error'
        this.alerting()
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Agencies/AgenciesBalance.vue